import React from "react";
import { convertToDateString, convertToDollar, formatDataProperties } from "../../Helpers";
import BCEmptyState from "../ui/BCEmptyState";
import BCMenuBar from "../ui/BCMenuBar";
import BCTable from "../ui/BCTable";
import BWExportButton from "./BWExportButton";
import BWSearchBox from "./BWSearchBox";

interface IBWWorkInspectionInteriorTableProps {
    isGreaterThanMobile: boolean;
    isGreaterThanTablet?: boolean;
    additionalMenuBarLeftChildren?: Array<JSX.Element>;
    additionalMenuBarRightChildren?: Array<JSX.Element>;
    interiorTableData: any;
    interiorTableSortable: Array<string>;
    emptyStateIcon: any;
    emptyStateText: any;
    dataRules?: any;
    formatRules?: any;
}

const BWWorkInspectionInteriorTable = ({...props} : IBWWorkInspectionInteriorTableProps) => {
    const menuBarLeftChildren = props.additionalMenuBarLeftChildren ? [<BWExportButton />, ...props.additionalMenuBarLeftChildren] : [<BWExportButton />];
    const menuBarRightChildren = props.additionalMenuBarRightChildren ? [<BWSearchBox />, ...props.additionalMenuBarRightChildren] : [<BWSearchBox />];
    const convertToTableFormat = (items : Array<any>) => {
        const result = [] as any[];
        items.forEach((item) => {
            const resultItem = {};
            Object.keys(item).forEach(key => {
                if (key === "inspectedOn"
                || key === "completedOn"
                || key === "dateInspected"
                || key === "scheduleDate"
                || key === "requestedDate") {
                    resultItem[key] = new Date(item[key]).toLocaleDateString();
                } 
                else if (key === "createdOn" || key === "updatedOn") {
                    resultItem[key] = convertToDateString(item[key], "dateTimeWithoutSecond");
                }
                else if (key === "budgetAmount") {
                    resultItem[key] = convertToDollar(item[key]);
                }
                else {
                    resultItem[key] = item[key];
                }
            });
            result.push(resultItem);
          });
      return formatDataProperties(result, props.formatRules);
    };

    return (
        <React.Fragment>
            <BCMenuBar 
              isGreaterThanMobile={props.isGreaterThanMobile}
              leftChildren={menuBarLeftChildren}
              rightChildren={menuBarRightChildren}
            />
            {props.interiorTableData && props.interiorTableData.length > 0 ?
              <BCTable 
                dataRules={props.dataRules || [{ field: "Id", rule: "hide" }]}
                data={convertToTableFormat(props.interiorTableData)}
                selectable
                overflowX
                dataSingleLine
                sortable={props.interiorTableSortable}
                pagination={15}
              /> :<div>
              <BCEmptyState
                emptyStateClass="inspection-empty-state"
                icon={props.emptyStateIcon}
                text={props.emptyStateText}
              /></div>
            }
        </React.Fragment>
    );
  };
  
export default BWWorkInspectionInteriorTable;